import './index.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'reflect-metadata'; // DO NOT REMOVE THIS IMPORT
import { Container } from 'typedi';
import { Provider } from 'mobx-react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { browserRouter } from './router/browserRouter';
import ioc, { boot_di } from './services/ioc';
import { RootStore } from './store';
import { registerPagesStore } from './pages/stores';
import './i18n';
import { environment, TAG_MANAGER_CONFIG } from './environment/environment';
import { tagManagerInit } from '@shared';
import { AppContext } from './app-context';
import { Auth0Provider } from '@auth0/auth0-react';
import { getAuth0RedirectUri } from './router/postLogin.utils';

boot_di();
setTimeout(() => {
    registerPagesStore();
    tagManagerInit(TAG_MANAGER_CONFIG);
    const rootStore = Container.get(RootStore);
    rootStore.routing.init(browserRouter);

    const { AUTH0 } = environment;
    const redirectUrl = getAuth0RedirectUri();

    const root = createRoot(document.getElementById('root') as HTMLElement);
    root.render(
        <Provider rootStore={rootStore} {...rootStore}>
            <AppContext.Provider value={{ ioc: ioc as any, rootStore }}>
                <Auth0Provider
                    domain={AUTH0.domain}
                    clientId={AUTH0.clientId}
                    authorizationParams={{
                        scope: AUTH0.scope,
                        audience: AUTH0.audience,
                        redirect_uri: redirectUrl,
                    }}
                    useRefreshTokens={true}
                    cacheLocation={AUTH0.cacheLocation}
                >
                    <RouterProvider router={browserRouter} />
                </Auth0Provider>
            </AppContext.Provider>
        </Provider>,
    );
});
